
export const audienceTranslations = {
  forWhomTitle: {
    fr: "À qui s'adresse Singularité.club",
    en: "Who Singularité.club is for"
  },
  entrepreneurs: {
    fr: "Entrepreneurs en activité",
    en: "Active entrepreneurs"
  },
  entrepreneursDesc: {
    fr: "Fondateurs et dirigeants d'entreprises innovantes",
    en: "Founders and leaders of innovative companies"
  },
  techLeaders: {
    fr: "CTO / Tech leads / Builders",
    en: "CTO / Tech leads / Builders"
  },
  techLeadersDesc: {
    fr: "Leaders techniques et développeurs visionnaires",
    en: "Technical leaders and visionary developers"
  },
  investors: {
    fr: "Investisseurs",
    en: "Investors"
  },
  investorsDesc: {
    fr: "VC, angels et family offices qui soutiennent l'innovation",
    en: "VCs, angels and family offices supporting innovation"
  },
  experts: {
    fr: "Experts",
    en: "Experts"
  },
  expertsDesc: {
    fr: "Spécialistes IA, Web3, produit, growth et stratégie",
    en: "AI, Web3, product, growth and strategy specialists"
  },
  communityLeaders: {
    fr: "Leaders communautaires",
    en: "Community leaders"
  },
  communityLeadersDesc: {
    fr: "Activistes tech et catalyseurs de changement",
    en: "Tech activists and change catalysts"
  },
  joinClub: {
    fr: "Rejoindre le club",
    en: "Join the club"
  },
  ecosystemDesc: {
    fr: "Un réseau interconnecté d'innovateurs et d'experts",
    en: "An interconnected network of innovators and experts"
  }
};
